import { facadeApi } from 'api'
import { ProjectNavigation } from 'types/projects/projectNavigation'

interface Params {
  projectId: string
}

export const fetchProjectNavigationApi = ({ projectId }: Params) =>
  facadeApi.get<ProjectNavigation>(`/projects/${projectId}/navigation`)
